import { Link } from "react-router-dom";
import LegalLayout from "@/pages/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="mb-2.5 mt-8 text-[18px] font-medium text-brand-ink">{children}</h2>
);

export default function Privacidad() {
  return (
    <LegalLayout title="Política de privacidad" docTitle="Política de privacidad — Asistentes Virtual">
      <H2>1. Responsable del tratamiento</H2>
      <ul className="mb-3.5 mt-2 list-disc pl-6">
        <li>Responsable: [NOMBRE Y APELLIDOS o RAZÓN SOCIAL]</li>
        <li>NIF/CIF: [NIF O CIF]</li>
        <li>Domicilio: [DIRECCIÓN COMPLETA]</li>
        <li>Correo electrónico: hola@asistentesvirtual.com</li>
      </ul>

      <H2>2. Datos que recogemos y finalidad</H2>
      <p>
        A través del formulario de contacto recogemos: nombre, correo electrónico, empresa o
        actividad y el contenido del mensaje. Estos datos se utilizan exclusivamente para
        responder a tu solicitud, elaborar una propuesta de servicios y, en su caso, gestionar
        la relación comercial posterior.
      </p>
      <p className="mt-2">
        Si aceptas las cookies publicitarias, Google Ads recoge datos de navegación con fines de
        medición de campañas, tal y como se detalla en la{" "}
        <Link to="/cookies" className="text-brand-indigo underline">política de cookies</Link>.
      </p>

      <H2>3. Legitimación</H2>
      <p>
        La base legal para el tratamiento es el consentimiento del interesado (art. 6.1.a RGPD),
        otorgado al enviar el formulario o aceptar las cookies, y la aplicación de medidas
        precontractuales a petición del interesado (art. 6.1.b RGPD) cuando se solicita una
        propuesta de servicios.
      </p>

      <H2>4. Destinatarios</H2>
      <p>
        No se ceden datos a terceros salvo obligación legal. Para la prestación del servicio
        utilizamos los siguientes encargados del tratamiento:
      </p>
      <ul className="mb-3.5 mt-2 list-disc pl-6">
        <li>
          [TU PROVEEDOR DEL FORMULARIO / GESTIÓN DE SOLICITUDES], como encargado del tratamiento
          de los datos enviados a través del formulario de contacto, con las garantías previstas
          en el RGPD.
        </li>
        <li>Google Ireland Ltd. (Google Ads, solo si aceptas las cookies publicitarias).</li>
        <li>[TU PROVEEDOR DE HOSTING] (alojamiento web).</li>
      </ul>

      <H2>5. Plazo de conservación</H2>
      <p>
        Los datos se conservarán mientras dure la relación comercial o hasta que solicites su
        supresión y, después, durante los plazos legalmente exigibles para la atención de
        posibles responsabilidades.
      </p>

      <H2>6. Derechos</H2>
      <p>
        Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación
        del tratamiento y portabilidad escribiendo a hola@asistentesvirtual.com, acreditando tu
        identidad. También tienes derecho a retirar el consentimiento en cualquier momento y a
        presentar una reclamación ante la Agencia Española de Protección de Datos (
        <a href="https://www.aepd.es" rel="noopener noreferrer" target="_blank" className="text-brand-indigo underline">www.aepd.es</a>).
      </p>

      <H2>7. Seguridad</H2>
      <p>
        Aplicamos las medidas técnicas y organizativas adecuadas para garantizar la
        confidencialidad e integridad de los datos, incluida la transmisión cifrada mediante
        HTTPS.
      </p>

      <p className="mt-8 text-[13px]">Última actualización: [FECHA]</p>
    </LegalLayout>
  );
}
